export default "__VITE_ASSET__DCERtgWU__"